var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlcohol(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_45131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6345 9.47612V0.5H17.0095V9.47612C15.0461 9.90644 13.572 11.6594 13.572 13.75V15.5625H6.65283L5.99152 19.5304C5.76664 20.8795 6.14477 22.2518 7.02883 23.2954C7.70727 24.0962 8.62596 24.6336 9.63452 24.8409V30.625H7.13346V32.5H26.072V13.75C26.072 11.6594 24.5979 9.90644 22.6345 9.47612ZM8.45952 22.0834C7.93239 21.4612 7.70696 20.643 7.84102 19.8386L8.24121 17.4375H12.9028L13.303 19.8386C13.4371 20.643 13.2116 21.4612 12.6845 22.0834C12.1575 22.7056 11.3875 23.0625 10.572 23.0625C9.75652 23.0625 8.98658 22.7056 8.45952 22.0834ZM13.572 30.625H11.5095V24.8409C12.2695 24.6847 12.9785 24.3415 13.572 23.8386V30.625ZM18.8845 2.375H20.7595V4.25H18.8845V2.375ZM24.197 30.625H15.447V13.75C15.447 12.3715 16.5685 11.25 17.947 11.25H18.8845V6.125H20.7595V11.25H21.697C23.0755 11.25 24.197 12.3715 24.197 13.75V15.5625H19.822V26.1875H24.197V30.625ZM24.197 24.3125H21.697V17.4375H24.197V24.3125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_45131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcohol);
export default __webpack_public_path__ + "static/media/Alcohol.21451dfa09af27a5704b806acc8541b4.svg";
export { ForwardRef as ReactComponent };